import getValuesArray from "../../../../utils/get-values-array";

/**
 * Get computed parameters data
 * @param {PropertyValueProps} parameter
 * @returns {TriggerParameterComputedDataProps}
 */
const getParametersData = (parameter) => {
  const map = new Map();

  let name = null;
  let value = null;
  let values = null;
  let unit = null;
  let multiple = false;

  /** Parameter is function `<method: delta(30)` */
  if (parameter.get("is-fn")) {
    name = parameter.get("name");
    values = getValuesArray(parameter.get("values"));
    multiple = true;
  } else {
    value = parameter.get("value");
    unit = parameter.get("unit");
    name = value;
  }

  map.set("value", value);
  map.set("values", values);
  map.set("name", name);
  map.set("unit", unit);
  map.set("is-multiple", multiple);

  return map;
};

export default getParametersData;
